<script setup lang="ts">
import {
  NConfigProvider,
  NDialogProvider,
  NMessageProvider,
  darkTheme,
} from 'naive-ui'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { localeBundle, type AppLocale } from '@/i18n'
import { lightThemeOverrides, darkThemeOverrides } from '@/theme'

const isDark = ref(false)
const theme = computed(() => (isDark.value ? darkTheme : null))
const themeOverrides = computed(() =>
  isDark.value ? darkThemeOverrides : lightThemeOverrides,
)

const { locale } = useI18n()
const naiveLocale = computed(() => localeBundle(locale.value as AppLocale).naive)
const naiveDateLocale = computed(() => localeBundle(locale.value as AppLocale).naiveDate)
</script>

<template>
  <NConfigProvider
    :theme="theme"
    :theme-overrides="themeOverrides"
    :locale="naiveLocale"
    :date-locale="naiveDateLocale"
  >
    <NMessageProvider>
      <NDialogProvider>
        <RouterView />
      </NDialogProvider>
    </NMessageProvider>
  </NConfigProvider>
</template>
